module.exports = __webpack_public_path__ + "img/bcard_6.c5aaee29.png";